module.exports = __webpack_public_path__ + "img/banner-23.a1cc4c35.jpg";